export default "__VITE_ASSET__CU6R239j__"